/**
 * Utility that allows to subscribe to and from events.
 * It also contains the enum of possible events.
 *
 * Event listener is invoked when the corresponding method is called. Listener receives promise of the future result
 * and the event object.
 *
 * Promise is resolved with corresponding object, depending on event, e.g. Folder, Item or List
 *
 * Promise is rejected with RejectReason object
 *
 * @namespace mediaManagerSDK.events
 * @memberof mediaManagerSDK
 *
 * @snippet subscribe.js
 */
/**
 * @typedef RejectReason
 * @type Object
 * @property {number} code
 * @property {string} message
 * @property {object} data
 *
 * @snippet codes.md
 */
/**
 * @typedef Event
 * @type Object
 * @property {object} eventTarget
 * @property {const} eventName
 */
import { addListener, removeListener } from './notifier';
import { eventsList } from './list';
const events = {
  ...eventsList
};
function defineNonEnumerableProperty(name, value) {
  Object.defineProperty(events, name, {
    enumerable: false,
    value
  });
}
defineNonEnumerableProperty('on', addListener);
defineNonEnumerableProperty('off', removeListener);
export { events };